import { API_ENDPOINTS } from "./config";

const CONTACTS_API = API_ENDPOINTS.contacts;

let contactPageRequest = null;

export const fetchContactPage = async () => {
  if (contactPageRequest) return contactPageRequest;

  contactPageRequest = fetch(CONTACTS_API)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch contact page data (${response.status})`);
      }

      const payload = await response.json();
      const contact = payload.data || payload.contacts?.[0] || null;

      return { contact };
    })
    .catch((error) => {
      contactPageRequest = null;
      throw error;
    });

  return contactPageRequest;
};
